import { useMutation } from "@tanstack/react-query";
import { validateAtreemoCredentials } from "../../api/bAtreemoApi";

export const useValidateAtreemo = () => {
  return useMutation({
    mutationKey: ["validate-atreemo"],
    mutationFn: (data) => validateAtreemoCredentials(data),
    onError: (error) => {
      console.error("Atreemo validation error details:", error.response || error);
    },
  });
};